<app-webnav  #navbarComponent (navbarButtonClick)="onNavbarBtnClicked($event)" [navForSharedCollection]="true" [sourceCollection]="collectionDetailsSource" (webpanelActionClick)="handleWebpanelClick($event)"></app-webnav>
<div [@cardFeedAnimation]="currentAnimationState"  class="shared-content-page" ngClass.lt-sm="shared-content-page-lt-sm" ngClass.lt-md="shared-content-page-lt-md" ngClass.gt-sm="shared-content-page-gt-sm" ngClass.gt-lg="shared-content-page-gt-lg">

    <div class="nodata-wrapper" *ngIf="isNoDataRecieved">
      <h1 class="nodata-title">Something went wrong :(</h1>
      <h3 class="nodata-desc">{{errorData}}</h3>
    </div>
    <div class="store-gallery-overlay" *ngIf="isCollectionDetailsShown">
      <app-thumbnail-gallery
        #thumbnailGallery
        class="no-title zero-margin last-slider"
        [sourceCards]="collectionDetailsSource?.collectionCards ?? []" [sortField]="'modifiedDate'"
        (cardClicked)="onStoreThumbClicked($event)">
      </app-thumbnail-gallery>
    </div>
    <div [@homeOverscrollAnimation]="isModelFeedVisible" class="shared-content-overscroll-background" *ngIf="isModelFeedVisible"></div>

    <app-web-models-card @modelFeedAnimation [feedMode]="CARDS_MODE.COMPOSITE_FEED" [feedModificator]="storeFeedModificator" #modelCardsFeed class="feed-overlap model-feed" *ngIf="isModelFeedVisible" [startPosition]="modelFeedCardStartPosition"[feedIsVisible]="isModelFeedVisible" [cardsRaw]="modelFeedCards"  (actionBtnClicked)="onCardCollectionControlBtnClicked($event)" (cardVisibilityChanged)="onCardVisibilityChanged($event)" ></app-web-models-card>

 </div>

<app-web-publishbulk *ngIf="isPublishBulkShown" [cardsToSelect]="cardSelectData" [allCardsToSelect]="cardSelectData" (cardSelected)="onPublishBulkSelected($event)"></app-web-publishbulk>
